module.exports = __webpack_public_path__ + "media/images/result_sets/circles/2n1r4r8n-1690847cb22007c8240b57962c3b4765.svg";